import { FirestoreInventoryItemProps } from "types/auth";

const STACK_INVENTORY_TYPES = ["WoodStack", "WoodChipStack", "WoodLogStack"] as const;

export function isStackInventoryType(inventoryType: unknown): boolean {
  return STACK_INVENTORY_TYPES.includes(
    inventoryType as (typeof STACK_INVENTORY_TYPES)[number],
  );
}

export function checkInventoryVisibleInMap(
  inventoryStatus: FirestoreInventoryItemProps["inventoryStatus"] | undefined,
  inventoryId: string | null,
  selectedFeatureId?: string | null
): boolean {
  if (!inventoryStatus || inventoryId === selectedFeatureId) return true;
  // Status "collected" don't insert
  if (["collected"].includes(inventoryStatus)) {
    return false;
  }
  return true;
}
